import difference from 'lodash/difference';
import keys from 'lodash/keys';
import pickBy from 'lodash/pickBy';
// eslint-disable-next-line no-restricted-imports
import { DirectMetricsGoalUI } from '../../../data-layer/direct/types';

export const makeIdentifiers = (mapping: Record<string, boolean>) => keys(pickBy(mapping, Boolean));

export const makeSelected = (selected?: string[]) =>
    (selected || []).reduce(
        (mapping, id) => ({
            ...mapping,
            [id]: true,
        }),
        {},
    );

export const isAllSelected = (goals: DirectMetricsGoalUI[], selectedIds: string[]) =>
    selectedIds.length > 0 &&
    difference(
        goals.map((goal) => goal.id),
        selectedIds,
    ).length === 0;

export const makeSelectedMapping = (goals: DirectMetricsGoalUI[]) =>
    goals.reduce(
        (mapping, goal) => ({
            ...mapping,
            [goal.id]: true,
        }),
        {},
    );
